module.exports = __webpack_public_path__ + "img/rw.2a59b860.svg";